import React from 'react';
import { PRODUCT_TYPES } from '../../../../constants';

const ProductFormModal = React.memo(({
  showForm,
  formData,
  setFormData,
  editingProduct,
  isSaving,
  formError,
  formSuccess,
  handleSave,
  handleCancel
}) => {
  if (!showForm) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && handleCancel()}>
      <div className="product-form-modal">
        <div className="modal-header">
          <h3>{editingProduct ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}</h3>
          <button className="modal-close" onClick={handleCancel}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleSave} className="product-form">
          <div className="form-group">
            <label>Ürün Tipi *</label>
            <select
              value={formData.productType}
              onChange={(e) => setFormData(prev => ({ ...prev, productType: e.target.value }))}
              disabled={isSaving}
            >
              {Object.entries(PRODUCT_TYPES).map(([key, type]) => (
                <option key={key} value={key}>{type.label}</option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Ürün Adı *</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
              placeholder="örn. Karya Düz Tül"
              disabled={isSaving}
              autoFocus
            />
          </div>

          {(formData.productType === 'ahsapJaluzi') ? (
            <div className="jaluzi-price-grid">
              <h5 className="section-subtitle">Dinamik Fiyatlandırma (₺)</h5>
              <div className="jaluzi-grid-row form-row">
                <div className="form-group">
                  <label>Merdiven İpli Satış Fiyatı</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.merdivenIpliFiyat}
                    onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliFiyat: e.target.value }))}
                    disabled={isSaving}
                  />
                </div>
                <div className="form-group">
                  <label>Kurdeleli Satış Fiyatı</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.kurdeleliFiyat}
                    onChange={(e) => setFormData(prev => ({ ...prev, kurdeleliFiyat: e.target.value }))}
                    disabled={isSaving}
                  />
                </div>
              </div>

              <div className="jaluzi-grid-row form-row">
                <div className="form-group">
                  <label>Merdiven İpli Redüktörlü Satış Fiyatı</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.merdivenIpliReduktorluFiyat}
                    onChange={(e) => setFormData(prev => ({ ...prev, merdivenIpliReduktorluFiyat: e.target.value }))}
                    disabled={isSaving}
                  />
                </div>
                <div className="form-group">
                  <label>Kurdelalı Redüktörlü Satış Fiyatı</label>
                  <input
                    type="number"
                    step="0.01"
                    value={formData.kurdelaliReduktorluFiyat}
                    onChange={(e) => setFormData(prev => ({ ...prev, kurdelaliReduktorluFiyat: e.target.value }))}
                    disabled={isSaving}
                  />
                </div>
              </div>
            </div>
          ) : formData.productType === 'rustik' ? (
            <div className="rustik-info-msg" style={{ marginBottom: '15px', color: '#64748b', fontSize: '0.85rem' }}>
              <i className="fas fa-info-circle"></i> Rustik ürünleri için fiyatlandırma, sipariş sırasında ayak ve aksesuarlar üzerinden otomatik hesaplanır. Burada sadece ürün adı girilmelidir.
            </div>
          ) : (
            <>
              <div className="form-row">
                <div className="form-group">
                  <label>Birim Fiyat (Satış - ₺) *</label>
                  <input
                    type="number"
                    step="0.01"
                    min="0"
                    value={formData.unitPrice}
                    onChange={(e) => setFormData(prev => ({ ...prev, unitPrice: e.target.value }))}
                    placeholder="0.00"
                    disabled={isSaving}
                  />
                </div>
              </div>

              {formData.productType === 'stor' && (
                <div className="form-group stor-width-limit-field">
                  <label className="stor-width-limit-label">
                    <input
                      type="checkbox"
                      checked={!!formData.maxWidth200cm}
                      onChange={(e) => setFormData(prev => ({ ...prev, maxWidth200cm: e.target.checked }))}
                      disabled={isSaving}
                    />
                    <span>
                      <strong>Maks. En: 200 cm</strong>
                      <small>Siparişte bu ürün için en değeri 200 cm&apos;yi aşamaz</small>
                    </span>
                  </label>
                </div>
              )}
            </>
          )}

          {formError && (
            <div className="form-error">
              <i className="fas fa-exclamation-circle"></i> {formError}
            </div>
          )}
          {formSuccess && (
            <div className="form-success">
              <i className="fas fa-check-circle"></i> {formSuccess}
            </div>
          )}

          <div className="form-actions">
            <button type="button" className="btn-cancel" onClick={handleCancel} disabled={isSaving}>
              İptal
            </button>
            <button type="submit" className="btn-save" disabled={isSaving}>
              {isSaving ? (
                <><i className="fas fa-spinner fa-spin"></i> Kaydediliyor...</>
              ) : (
                <><i className="fas fa-save"></i> {editingProduct ? 'Güncelle' : 'Kaydet'}</>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
});

export default ProductFormModal;
